@import '../../react-web-ui/assets/styles/mixins';
@import '../../react-web-ui/assets/styles/variables';

:root {
  --fc-button-bg-color: var(--accent-color);
  --fc-button-border-color: var(--accent-color);
  --fc-button-hover-bg-color: var(--accent-color);
  --fc-button-hover-border-color: var(--accent-color);
  --fc-button-active-bg-color: var(--accent-color);
  --fc-button-active-border-color: var(--accent-color);
}


.event-block {
  position: relative;
  width: 100%;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    //margin-bottom: -4px;
  }

}

.event-information {

  h2 {
    margin: 0;
    font-size: rem(16px);
  }

  p {
    margin-top: 5px;
    margin-bottom: 0;
  }

}


.event-calendar {
  height: 85px;
  cursor: pointer;

  h2 {
    white-space: wrap;
  }

  .event-information {
    display: flex;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    color: $white;
    padding: 4px;
    text-align: center;
    font-weight: bold;
  }

  &:hover .event-information {
    display: flex;
  }


}

.event-horizontal {
  position: relative;
  display: flex;
  margin-bottom: 10px;
  border-bottom: 1px solid $border-color;
  background-color: $white;
  padding: 10px;
  border-radius: 8px;

  img {
    flex-shrink: 0;
    width: 140px;
    border-radius: 8px;
    margin-right: 18px;
  }

  h2 {
    font-size: rem(20px);
    padding-right: 100px;
  }

  .event-information {
    width: 100%;



    @include medium {
      >div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;

      }
    }

  }

  .event-hours {
    color: $accent-color;
    font-style: italic;
  }

  &:last-child {
    border-bottom: 0;
  }

}

@include medium {
  .month-day {
    display: none;
  }

  .event-calendar {

    height: 85px;

    .event-information {

      background: rgba(0, 0, 0, 0.7);
      display: none;
    }

  }

  .event-horizontal .event-hours {
    position: absolute;
    right: 10px;
    top: 0;
    width: 100px;
    text-align: right;
  }

}
